import{a as e}from"./chunk-BQCKYTMH.mjs";import{b as m}from"./chunk-TN4M2PHH.mjs";import{h as r,i as o}from"./chunk-2JBE4HP3.mjs";var i=new r({locale:[e,m,o]});export{i as a};
